/**
 * Admin API often responds with HTTP 200 and a JSON body `{ status, message, data }`.
 * Use this after axios.post to detect real success vs failure.
 */
export function isApiSuccessStatus(status) {
  return status >= 200 && status < 300;
}

export function assertApiSuccess(response) {
  const body = response?.data;
  if (!body || !isApiSuccessStatus(body.status)) {
    const message = body?.message || 'Request failed';
    return { ok: false, message };
  }
  return { ok: true, data: body.data, message: body.message };
}

export function throwUnlessApiSuccess(response) {
  const result = assertApiSuccess(response);
  if (!result.ok) {
    throw new Error(result.message);
  }
  return result.data;
}

export function getApiErrorMessage(error, fallback = 'Request failed') {
  return error?.message || error?.response?.data?.message || fallback;
}
